import {dashboardApi, triggersApi} from 'sources/api';
import {Metric} from 'records/Metric';
import {List} from 'immutable';
import {resolveMetricTeamFilter} from 'actions/ExecDashboard.utils';

const dateFormat = 'YYYY-MM-DD';

export const HierarchyType = Object.freeze({
  user: 'user',
  team: 'team',
  department: 'department',
});

export const StatType = Object.freeze({
  avg: 'AVG',
  max: 'MAX',
  sum: 'SUM',
  per: 'PER',
});

export const MetricType = Object.freeze({
  // Call Related
  conversations: 'conversations',
  totalDuration: 'totalduration',
  avgDuration: 'avgduration',
  interchanges: 'interchanges',
  talkListen: 'talklisten',

  // Coaching Related
  libraryAdds: 'library_adds',
  listeningCount: 'listening_count',
  listeningPercent: 'listening_pct',
  listeningTime: 'listening_time',
  callsScored: 'calls_scored',
  scoring: 'scoring',
  commentsCount: 'comments_count',
  commentsLength: 'comments_length',
  highlightsCount: 'highlights_count',
  plans: 'plans',
  meetings: 'meetings',

  // Topic Related
  trigger: 'trigger',
});

export const DirectionType = Object.freeze({
  activity: '',
  reviewBySelf: 'review',
  coachBySelf: 'coach',
  coachByCoach: 'iscoach',
  coachByManager: 'manager',
  coachByOthers: 'other',
  coachByAnybody: 'any',
});

export default class DashMetricsSource {
  static userMetric(metric, {teamIds, direction, startDate, endDate, context}) {
    return dashboardApi
      .getJson(`/metrics/users/${metric}`, {
        params: {
          teams: teamIds.toJS(),
          direction,
          start_date: startDate.format(dateFormat),
          end_date: endDate.format(dateFormat),
          context,
        },
      })
      .then(metrics => List(metrics.map(Metric)));
  }

  static teamMetric(metric, {teamIds, direction, stat, startDate, endDate, context}) {
    return dashboardApi
      .getJson(`/metrics/team/${metric}`, {
        params: {
          direction,
          stat,
          context,
          start_date: startDate.format(dateFormat),
          end_date: endDate.format(dateFormat),
          ...resolveMetricTeamFilter(teamIds),
        },
      })
      .then(metrics => List(metrics.stats.map(Metric)));
  }

  static coachMetric(metric, {teamIds, direction, stat, startDate, endDate, context}) {
    return dashboardApi
      .getJson(`/metrics/coach/${metric}`, {
        params: {
          direction,
          stat,
          context,
          start_date: startDate.format(dateFormat),
          end_date: endDate.format(dateFormat),
          ...resolveMetricTeamFilter(teamIds),
        },
      })
      .then(metrics => List(metrics.stats.map(Metric)));
  }

  /**
   * Returns a normal metric payload with id being userId and value being a callId
   */
  static callsForMetric({hierarchy, metric, direction, ids, limit, startDate, endDate, ruleId}) {
    return dashboardApi
      .getJson(`/metrics/calls/${hierarchy}/${metric}`, {
        params: {
          start_date: startDate.format(dateFormat),
          end_date: endDate.format(dateFormat),
          context: ruleId,
          direction,
          ids: ids.toJS(),
          limit,
        },
      })
      .then(metrics => List(metrics.map(Metric)));
  }

  static topicIdsForTriggerId(triggerId) {
    return triggersApi.getJson(`/filter_word_usage/topics/${triggerId}`);
  }
}
